import { getBrands } from "@components/config/helpers";
import dynamic from "next/dynamic";
import Head from "next/head";

const Services = dynamic(() => import('@components/Components/Services/components/Services'));

const Page = ({ data }) => {
    return (
        <>
            <Head>
                <title>{`${process.env.brand.brand_name} Learn about the UK's leading Portable Bar Providers`}</title>
                <meta
                    name="description"
                    content={`${process.env.brand.brand_name} UK are the UK's leading portable bar provider for events throughout the UK and Europe. With Bar Counters and Cash Bar solutions for the events industry the company is a vital component at Festivals, Parties, Weddings and Corporate Events across England, Wales, Scotland and also well into Europe.`}
                />
            </Head>

            <Services />
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=43200, stale-while-revalidate=59'
      );

    if(!getBrands(['MBH'])) {
        return {notFound: true}
    }
    
    return {
        props: {
        },
    };
}

export default Page;
